import { useResponsive } from '@/lib/useResponsive';
import { cn } from '@/lib/utils';
import {} from '@/misc/images';
import { ChevronDownDouble } from '@untitled-ui/icons-react';
import type { PropsWithChildren } from 'react';
import React from 'react';

interface Props {
  ariaLabel: string;
  image: string;
  mobileImage?: string;
  imageAlt: string;
  overlay?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const Header = ({
  children,
  ariaLabel,
  image,
  mobileImage,
  imageAlt,
  overlay,
  className,
}: PropsWithChildren<Props>) => {
  const { isMobile, md, sm } = useResponsive();

  const isMobileDevice = isMobile || sm || md;

  return (
    <header
      className={cn('relative w-full h-[100dvh] md:h-[75dvh]', className)}
      aria-label={ariaLabel}
    >
      {/* BG IMAGE */}
      {isMobileDevice ? (
        <img
          src={mobileImage}
          alt={imageAlt}
          className="absolute top-0 left-0 size-full min-h-[100dvh] min-w-[100dvw] object-cover z-0 md:min-h-[75dvh] md:min-w-[75dvw]"
        />
      ) : (
        <img
          src={image}
          alt={imageAlt}
          className="absolute top-0 left-0 size-full object-cover z-0"
        />
      )}
      {/* OVERLAY */}
      {overlay ? (
        <>{overlay}</>
      ) : (
        <div className="absolute top-0 left-0 w-full h-full bg-bg-brand opacity-60 z-10" />
      )}

      {/* HEADER CONTENT */}
      {children}

      {/* SCROLL DOWN ICON */}
      {isMobileDevice && (
        <div className="absolute inset-0 bottom-8 z-20 flex items-end justify-center animate-pulse">
          <div className="relative flex flex-col items-center justify-center size-9 bg-transparent border border-white rounded-full z-20">
            <ChevronDownDouble className="absolute text-white size-7" aria-hidden="true" />
          </div>
        </div>
      )}
    </header>
  );
};
